export const numericSort = (rowA, rowB, fieldName) => {
  return rowA.original[fieldName] > rowB.original[fieldName] ? 1 : -1;
};

export const dateSort = (rowA, rowB, fieldName) => {
  const dateA = new Date(rowA.original[fieldName]).getTime();
  const dateB = new Date(rowB.original[fieldName]).getTime();
  return dateA > dateB ? 1 : -1;
};
